import CircleIcon from '@mui/icons-material/Circle';
import '../App.css';
import { StyleConstants, Styles } from '../Styles';

const GreenLightIcon = () => {
    return (
        <CircleIcon 
            sx={{
                fill: StyleConstants.normalColor,
                ...Styles.light,
            }}
        />
    );
};

export default GreenLightIcon;